import {
    DELIVERYOPTION_SELECTED_NAME,
    ITEM_AVAILABILITY,
    BOPIS_ITEM_AVAILABILITY,
} from '../actionTypes/DeliveryOptionActionTypes';

function DeliveryOptionsNameReducer(state = {}, action) {
    switch (action.type) {
        case DELIVERYOPTION_SELECTED_NAME:
            return { ...state, ...action.selectedDeliveryOption };
        case ITEM_AVAILABILITY:
            return { ...state, ...action.selectedItemAvailability };
        case BOPIS_ITEM_AVAILABILITY:
            return { ...state, ...action.selectedItemBopisAvailability };
        default:
            return state;
    }
}

export default DeliveryOptionsNameReducer;
